import React from 'react';
import { IconButton } from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';

import { Confirmation } from 'components/common';
import { ShipmentDetailsDTO } from '../../types';

const InterceptionAction = ({ onClick }: { onClick?: () => void }) => (
  <IconButton aria-label="Request UPS delivery interception" size="small" onClick={onClick}>
    <Edit fontSize="small" />
  </IconButton>
);

const CancelInterceptionAction = ({ record }: { record?: ShipmentDetailsDTO }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleCancel = async () => {
    if (!record?.id) {
      notify('Shipment ID is required', 'error');
      return;
    }

    try {
      await dataProvider.delete('shipmentInterceptionCancellation', {
        shipmentId: record.id,
      });

      refresh();
    } catch (error: any) {
      notify(error?.message || 'Unable to cancel shipment interception', 'error');
    }
  };

  return (
    <Confirmation
      title="Cancel UPS delivery interception"
      content="Are you sure you want to cancel this shipment interception?">
      <IconButton aria-label="Cancel UPS delivery interception" size="small" onClick={handleCancel}>
        <Delete fontSize="small" />
      </IconButton>
    </Confirmation>
  );
};

const InterceptionActions = ({
  record,
  onEdit,
}: {
  record?: ShipmentDetailsDTO;
  onEdit: () => void;
}) => (
  <>
    <InterceptionAction onClick={onEdit} />
    {!!(record?.interceptionType || record?.interceptedAt) && (
      <CancelInterceptionAction record={record} />
    )}
  </>
);

export default InterceptionActions;
